import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" data-mp="35c23whp4t7xc" />
      <LandingPage data-id="element-1" data-mp="35eogwwuskfmy" />
    </>;
}